export default __webpack_public_path__ + "static/24-928b26c549553a2e9edb094cc6fe2dda.jpg";